// import dotenv from 'dotenv';
import ConnectWith from "./components/ConnectWith";
import Introduction from "./components/Introduction";
import NavBar from "./components/Navbar";
import Skills from "./components/Skills";
import WeatherAndYt from "./components/WeatherAndYt";
// dotenv.config();

function App() {
  return (
    <div className="App">
      <NavBar />
      <Introduction />
      <Skills />
      <WeatherAndYt />
      <ConnectWith />
    </div>
  );
}

export default App;
